import AxiosFunction from "../../core/helpers/axios/AxiosFunction";
import AppFunction from '../../core/helpers/app/AppFunction'
import axios from 'axios';

export const urlGenerator = url => {
    if (!url) return AppFunction.getBaseUrl();
    return url.startsWith('http') ? url : `${AppFunction.getBaseUrl()}/${url.split('/').filter(d => d).join('/')}`;
};
// export const urlGenerator = url => `${AppFunction.getBaseUrl()}/${url.split('/').filter(d => d).join('/')}`;

export const axiosGet = (url, data = null) => {
    return AxiosFunction.axiosGet(urlGenerator(url), data);
};

export const axiosPost = (url, data) => {
    return AxiosFunction.axiosPost({
        url: urlGenerator(url),
        data
    });
};

export const axiosPatch = (url, data) => {
    return AxiosFunction.axiosPatch({
        url: urlGenerator(url),
        data
    });
};

export const axiosDelete = (url) => {
    return AxiosFunction.axiosDelete(urlGenerator(url));
};

/**
 * Get the API Bearer token from various sources
 */
export const getApiToken = () => {
    return sessionStorage.getItem('rawafed_api_token') || 
           document.querySelector('meta[name="api-token"]')?.getAttribute('content') ||
           document.querySelector('meta[name="rawafed_api_token"]')?.getAttribute('content') ||
           null;
};

/**
 * Get the external API base URL
 * Checks meta tag first, then defaults to config value
 */
export const getExternalApiBaseUrl = () => {
    const metaUrl = document.querySelector('meta[name="rawafed-api-url"]')?.getAttribute('content');
    if (metaUrl) return metaUrl;
    
    // Default to the configured API URL (from config/services.php)
    // This should be set via a meta tag in the layout, but fallback to default
    return 'https://rawafed.websoft.sa';
};

/**
 * Make an authenticated API call to the external API
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {string} endpoint - API endpoint (e.g., '/api/users/profile')
 * @param {object} data - Request body data
 * @returns {Promise} Axios promise
 */
export const externalApiCall = (method, endpoint, data = null) => {
    const token = getApiToken();
    const baseUrl = getExternalApiBaseUrl();
    const url = endpoint.startsWith('http') ? endpoint : `${baseUrl}${endpoint}`;
    
    const language = localStorage.getItem('app-language') || 'en';
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept-Language': language.toLowerCase()
    };
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    const config = {
        method: method.toLowerCase(),
        url: url,
        headers: headers,
        withCredentials: false // External API, no credentials
    };
    
    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
        config.data = data;
    }
    
    return axios(config);
};
